module.exports = __webpack_public_path__ + "static/sport/title.cd52a22.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/invite/title.png
// module id = ufJg
// module chunks = 0